import { render } from "./SaveElementModal.vue?vue&type=template&id=d7b78406"
import script from "./SaveElementModal.vue?vue&type=script&lang=ts"
export * from "./SaveElementModal.vue?vue&type=script&lang=ts"

import "./SaveElementModal.vue?vue&type=style&index=0&id=d7b78406&lang=scss"
script.render = render

export default script